import { ADMIN_TASK_IDS } from "@/shared/constants/taskIds";
import type { FlowScreen, FlowScreenConfig } from "@/shared/constants/flowTypes";

import { createWillSearchScreens } from "./willSearch";
import { createFamilyTriageScreens } from "./familyTriage";
import { createConfirmAdminScreens } from "./confirmAdmin";
import { createAdminSignoffScreens } from "./adminFamilySignoffs";
import { createAdminResultsScreens } from "./adminFormPacket";

function normalizeScreen(config: FlowScreenConfig): FlowScreen {
  if (!config.question) return config as FlowScreen;
  return { ...config, question: { ...config.question, id: config.id } } as FlowScreen;
}

const ADMIN_TASK_SCREEN_BUILDERS: Record<string, () => FlowScreenConfig[]> = {
  [ADMIN_TASK_IDS.WILL_SEARCH]: createWillSearchScreens,
  [ADMIN_TASK_IDS.FAMILY_TRIAGE]: createFamilyTriageScreens,
  [ADMIN_TASK_IDS.CONFIRM_ADMIN]: createConfirmAdminScreens,
  [ADMIN_TASK_IDS.FAMILY_SIGNOFFS]: createAdminSignoffScreens,
  [ADMIN_TASK_IDS.FORMS_PACKET]: createAdminResultsScreens,
};

export function buildAdminScreensForTask(taskId: string): FlowScreen[] {
  const builder = ADMIN_TASK_SCREEN_BUILDERS[taskId];
  if (!builder) return [];
  return builder().map(normalizeScreen);
}
